import {
    DATA_ID_ATTRIBUTE,
    MIN_IMG_HEIGHT_ATTRIBUTE,
    DETAILS_VIEW_ATTRIBUTE_IMG,
    ZOOM_IN_ATTRIBUTE,
} from '@core/constants/ATTRIBUTES';

/**
 * @type {string}
 * @description - The img card web component.
 */
export const SEARCH_IMG_CARD_WEB_COMPONENT = 'search-img-card-component';

/**
 * @type {{
 *  ZOOM_IN: string;
 *  IMAGE: string;
 *  MIN_IMG_HEIGHT: string;
 *  ACTIVE_ID: string;
 *  LIGHTBOX_ITEM: string;
 * }}
 * @description - The img card attributes.
 */
export const SEARCH_IMG_CARD_ATTRIBUTES = {
    ZOOM_IN: ZOOM_IN_ATTRIBUTE,
    IMAGE: DETAILS_VIEW_ATTRIBUTE_IMG,
    MIN_IMG_HEIGHT: MIN_IMG_HEIGHT_ATTRIBUTE,
    ACTIVE_ID: DATA_ID_ATTRIBUTE,
    LIGHTBOX_ITEM: 'lightbox-item',
};

/**
 * @type {string}
 * @description - The custom search img card loading spinner web component.
 */
export const CUSTOM_SEARCH_IMG_CARD_LOADING_SPINNER_WEB_COMPONENT =
    '[data-search-img-card-spinner]';
